import React, { useState } from "react";
import Slider from "react-slick";
import { banner1, banner2, banner3, 
  
} from "../assets/images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "./designlayouts/Image";  

// Inline CSS to ensure dot positioning and reset slick defaults
// const bannerStyles = `
//   .banner-dots {
//     position: absolute !important;
//     top: 50% !important;
//     left: 7% !important;
//     transform: translateY(-50%) !important;
//     z-index: 10 !important;
//   }
//   .banner-dots ul {
//     margin: 0 !important;
//     padding: 0 !important;
//     list-style: none !important;
//   }
//   .banner-dots li {
//     text-align: left !important;
//   }
//   /* Reset slick-dots default centering */
//   .slick-dots {
//     text-align: left !important;
//     display: block !important;
//   }
//   @media (max-width: 576px) {
//     .banner-dots {
//       left: 2% !important;
//     }
//   }
// `;
const bannerStyles = `
  .slick-dots {
    display: none !important;
  }
`;

const Banner = () => {
  const [dotActive, setDocActive] = useState(0);
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div className="banner-dots">
        <ul style={{ margin: "0px", padding: "0px", listStyle: "none" }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "30px",
                color: "#262626",
                borderRight: "3px #262626 solid",
                padding: "8px 0",
                cursor: "pointer",
              }
            : {
                width: "30px",
                color: "transparent",
                borderRight: "3px white solid",
                padding: "8px 0",
                cursor: "pointer",
              }
        }
      >
        0{i + 1}
      </div>
    ),
    responsive: [
      {
        breakpoint: 576,
        settings: {
          dots: true,
          appendDots: (dots) => (
            <div className="banner-dots">
              <ul style={{ margin: "0px", padding: "0px", listStyle: "none" }}>
                {dots}
              </ul>
            </div>
          ),
          customPaging: (i) => (
            <div
              style={
                i === dotActive
                  ? {
                      width: "25px",
                      color: "#262626",
                      borderRight: "3px #262626 solid",
                      cursor: "pointer",
                      fontSize: "12px",
                    }
                  : {
                      width: "25px",
                      color: "transparent",
                      borderRight: "3px white solid",
                      cursor: "pointer",
                      fontSize: "12px",
                    }
              }
            >
              0{i + 1}
            </div>
          ),
        },
      },
    ],
  };

  return (
    <div className="w-full relative">
      {/* Inject inline styles */}
      <style>{bannerStyles}</style>
      <Slider {...settings}>
        <div style={{ width: "100%", height: "400px" }}>
          <Image imgSrc={banner1} />
        </div>
        <div style={{ width: "100%", height: "400px" }}>
          <Image imgSrc={banner2} />
        </div>
        <div style={{ width: "100%", height: "400px" }}>
          <Image imgSrc={banner3} />
        </div>
      </Slider>
    </div>
  );
};

export default Banner;